export const tags = [
    'StudyInstanceUID',
    'SeriesInstanceUID',
    'Modality',
    'SeriesDescription',
    'SeriesNumber',
    'SeriesDate',
    'SeriesTime',
    'AcquisitionDate',
    'AcquisitionTime',
];
